import { ReactElement, ReactNode } from 'react'
import { Box, Stack, Typography } from '@mui/material'

export interface LabelledValue {
  label: ReactNode
  /** Skipped entirely when `undefined` — an unknown value shows no field at all. */
  value?: ReactNode
}

export interface LabelledValueRowProps {
  items: LabelledValue[]
}

/**
 * A wrapping row of caption-over-value fields — the "Allgemein" layout of the Results2 detail
 * panes. Entries without a value are dropped rather than rendered empty.
 */
export const LabelledValueRow = ({ items }: LabelledValueRowProps): ReactElement => (
  <Stack
    direction="row"
    spacing={3}
    flexWrap="wrap"
    useFlexGap
    sx={{ pb: 1, '& > div': { minWidth: 120 } }}
  >
    {items
      .filter(item => item.value !== undefined)
      .map((item, index) => (
        <Box key={index}>
          <Typography variant="caption" color="text.secondary">
            {item.label}
          </Typography>
          <Typography variant="body2" fontWeight={600}>
            {item.value}
          </Typography>
        </Box>
      ))}
  </Stack>
)
